import { Icon } from '@blueprintjs/core';

interface Props {
  title: string;
}

export function LockedIcon({ title }: Props) {
  return (
    <Icon
      icon="lock"
      title={`${title} cannot be changed when a working list is applied.`}
    />
  );
}
